import dayjs from "dayjs";

import { DATE_FORMAT_READABLE } from "utils/date";

export const DETECTORS_SIZE = 15;
export const LABELERS_SIZE = 15;

export function extractDateFromString(input: string): string {
  const formatDate = (date: Date) => dayjs(date).format(DATE_FORMAT_READABLE);

  if (input === "from_db") {
    return formatDate(new Date());
  }

  const regex = /heatmap_(\d{4}-\d{2}-\d{2})-\d{2}-\d{2}-\d{2}\.pkl/;
  const match = input.match(regex);

  if (match && match[1]) {
    return formatDate(new Date(match[1]));
  }
  return formatDate(new Date());
}

export function generateBackgroundColor(value: number | null): string {
  if (value === null) return "#EEF4F7";

  const roundedValue = Math.floor(value * 10) / 10;

  const colorRanges = [
    { min: 0.0, max: 0.09, color: "#A50026" },
    { min: 0.1, max: 0.19, color: "#D02927" },
    { min: 0.2, max: 0.29, color: "#F46D43" },
    { min: 0.3, max: 0.39, color: "#FDB567" },
    { min: 0.4, max: 0.49, color: "#FEE08B" },
    { min: 0.5, max: 0.59, color: "#FFF8B4" },
    { min: 0.6, max: 0.69, color: "#D7EE8A" },
    { min: 0.7, max: 0.79, color: "#ABDB6D" },
    { min: 0.8, max: 0.89, color: "#69BE63" },
    { min: 0.9, max: 0.99, color: "#199750" },
    { min: 1.0, max: 1.0, color: "#006837" },
  ];

  const range = roundedValue
    ? colorRanges.find((r) => roundedValue >= r.min && roundedValue <= r.max)
    : { color: "#A50026" };
  return range ? range.color : "#EEF4F7";
}
